import FavoriteGames from './games/FavoriteGames';

class PlayerApi {
  favoriteGames = new FavoriteGames();
}

export default PlayerApi;
